<template>
  <v-form @submit="onSubmit">
    <service-form :doc="doc" />
    <v-btn class="mt-5" @click="onSubmit">Submit</v-btn>
  </v-form>
</template>

<script>
// @ is an alias to /src
import ServiceForm from "./ServiceForm"
const fb = require("@/firebaseConfig.js");

export default {
  name: "UserServiceEdit",
  components: {
    ServiceForm,
  },
  data() {
    return {
      doc: {},
    };
  },
  props: {
    id: String
  },
  created() {
    const ref = fb.exServiceNotesCollection.doc(this.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
      } else {
        alert("No such document!");
      }
    });
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      const updateRef = fb.exServiceNotesCollection.doc(this.id);
      updateRef
        .set(this.doc)
        .then(() => {
          this.doc = {};
          this.$emit('complete')
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
  },
};
</script>
